<template>
  <el-drawer title="销假" :visible.sync="drawer" :modal-append-to-body="false" append-to-body destroy-on-close :wrapperClosable="false" custom-class="widthCommon">
    <el-form ref="addForm" status-icon :model="addForm" :rules="rules" label-position="left" label-width="83px" size="small" class="mx-20-1 bg-#fff py-20 pr-30">
      <el-form-item label="销假原因：" prop="cancelReason">
        <el-input v-angle="addForm.cancelReason" v-model="addForm.cancelReason" placeholder="填写销假原因" :rows="4" maxlength="70" type="textarea" show-word-limit clearable />
      </el-form-item>
    </el-form>
    <FixedTwoButton activeClass="widthCommon">
      <ELButton size="small" describe="重置" :myFunction="resetForm" />
      <ELButton size="small" describe="提交" isAsync :myFunction="submitForm" type="primary" />
    </FixedTwoButton>
  </el-drawer>
</template>

<script>
import { quashLeave } from '@/api/workflow'

export default {
  inject: ['indexThis'],
  data() {
    return {
      drawer: false,
      addForm: {
        flowApplyOverviewId: '',
        cancelReason: '',
      },
      rules: {
        cancelReason: [{ required: true, message: '销假原因不能为空', trigger: 'change' }],
      },
    }
  },
  methods: {
    async submitForm() {
      const valid = await this.$refs.addForm.validate().catch(() => {})
      if (!valid) return false
      const { data: res } = await quashLeave(this.addForm)

      if (!res) return this.$message.error('销假失败')
      this.$message.success('销假成功')
      this.indexThis.init()
      this.resetForm()
      this.drawer = false
    },
    resetForm() {
      this.$refs.addForm.resetFields()
    },
  },
}
</script>
